<template>
  <div
    class="grid grid-cols-banner bannerBorder px-sm bg-white w-full min-h-bannerHeight">
    <div class="flex flex-wrap justify-center gap-base items-center">
      <div
        class="flex flex-wrap justify-content-start lg:justify-center gap-1.5 items-center py-1">
        <span class="banner-title text-warning font-bold">
          <slot name="title" />
        </span>
        <span class="banner-message text-warning">
          <slot name="message" />
        </span>
        <span class="cursor-pointer text-warning">
          <slot name="cta" />
        </span>
      </div>
    </div>
    <div class="flex justify-center items-center">
      <IconButton
        id="close-button"
        class="!rounded-full !px-twelve !py-eight"
        variant="warning"
        label="close-button"
        size="medium"
        icon="times"
        :data-ec="dataEc"
        data-et="close_banner"
        @click="closeBanner"
      />
    </div>
  </div>
</template>
<script>
import IconButton from '@/components/library/buttons/IconButton.vue';

export default {
  name: 'BaseBanner',
  components: {
    IconButton,
  },
  props: {
    dataEc: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeBanner() {
      this.$emit('bannerClosed');
    },
  },
};
</script>
